import { AdminApi } from 'stylemix-vue-admin'

export default class VehiclesApi extends AdminApi {
  constructor(parameters) {
    super('vehicles', parameters)
  }

  updateAvailability(id, availability) {
    return this.submit('post', `/${this.endpoint}/${id}/availability`, {
      available_everywhere: availability,
    })
  }
}
